export default __webpack_public_path__ + "static/homepage_video-abb85ff9401a0f0a9c7c2048a9deb15d.mp4";